import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="checkable"
export default class extends Controller {
  static targets = ["input",]
  declare readonly inputTarget: HTMLInputElement

  check(event: MouseEvent): void {
    if((event.target as HTMLElement).closest('a') !== null) return
    if((event.target as HTMLElement).closest('button') !== null) return
    if((event.target as HTMLElement).tagName === 'INPUT') return

    this.inputTarget.checked = !this.inputTarget.checked
    this.inputTarget.dispatchEvent(new Event('change'))
  }
}
